import { api } from "@/api"

import type { ProductModifierGroupIn } from "./productModifiers"
import { queryClient } from "@/queryClient"

export const createProductModifier = async (
  params: ProductModifierGroupIn
) => {
  const { body } = await api.post<{ id: string }>(
    "/products/product-modifiers/",
    {
      body: params,
    }
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCT_MODIFIERS_QUERY_KEY],
  })
  return body
}
